export default "__VITE_ASSET__9m2kiEJ9__"